import { motion } from "framer-motion";
import { Leaf, MessageCircle, ArrowRight, Phone } from "lucide-react";
import { useSiteContent } from "@/hooks/useContent";

const FALLBACK_IMG = "https://customer-assets.emergentagent.com/job_87c58432-5d7c-47ab-ad60-b480eb93388c/artifacts/bou3hxhr_IMG-20260410-WA0006.jpg";

export default function NutritionPage() {
  const { content } = useSiteContent();
  const n = content?.nutrition || {};
  const s = content?.settings || {};
  const wa = s.whatsapp || "919153020904";
  const features = n.features || [];

  return (
    <div data-testid="nutrition-page">
      <div className="page-header">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="font-heading text-gg-red text-xs uppercase tracking-[0.3em]">{n.subtitle || "Beyond Training"}</motion.span>
          <motion.h1 initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="font-heading text-2xl sm:text-3xl font-extrabold uppercase tracking-tight mt-1">
            Nutrition <span className="text-gg-red">Guidelines</span>
          </motion.h1>
        </div>
      </div>

      <section className="py-8 md:py-10">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex flex-col md:flex-row gap-10 md:gap-12 lg:gap-16">
            <motion.div initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.6 }} className="md:w-1/2">
              <p className="text-zinc-400 text-sm leading-relaxed tracking-wide">{n.description || ""}</p>
              <ul className="mt-5 space-y-2.5">
                {features.map((item, i) => (
                  <motion.li key={i} initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.1 * i + 0.3 }} className="flex items-center gap-3 text-zinc-300 text-sm tracking-wide group">
                    <Leaf size={14} className="text-gg-red shrink-0 group-hover:scale-110 transition-transform" /> {item}
                  </motion.li>
                ))}
              </ul>
              <div className="mt-6 flex flex-wrap gap-3">
                <a href={`https://wa.me/${wa}?text=Hi!%20I'm%20interested%20in%20Nutrition%20Consultation.`} target="_blank" rel="noopener noreferrer" data-testid="nutrition-book-cta"
                  className="inline-flex items-center gap-2 bg-gg-red hover:bg-gg-red-hover text-white px-5 py-2.5 rounded-lg font-heading text-xs uppercase tracking-widest transition-all duration-300 hover:shadow-xl hover:shadow-gg-red/30 hover:scale-[1.03] btn-press group">
                  <MessageCircle size={14} /> Book Consultation <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                </a>
                <a href={`tel:+${wa}`} className="inline-flex items-center gap-2 border border-white/20 text-white px-5 py-2.5 rounded-lg font-heading text-xs uppercase tracking-widest hover:border-gg-red hover:text-gg-red hover:bg-gg-red/5 transition-all duration-300 btn-press">
                  <Phone size={14} /> Call Me
                </a>
              </div>
            </motion.div>
            <motion.div initial={{ opacity: 0, x: 30, scale: 0.97 }} animate={{ opacity: 1, x: 0, scale: 1 }} transition={{ duration: 0.7, delay: 0.2 }} className="md:w-1/2">
              <div className="relative overflow-hidden rounded-xl border border-white/10 group img-zoom">
                <img src={n.image || FALLBACK_IMG} alt="Nutrition consultation in Bolpur Santiniketan" className="w-full aspect-[4/3] object-cover" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-gg-black/70 via-transparent to-transparent" />
                <div className="absolute bottom-5 left-5 right-5">
                  <p className="text-white font-heading text-sm md:text-base uppercase tracking-wider font-bold">Science-Based Nutrition</p>
                  <p className="text-zinc-300 text-xs mt-1 tracking-wide">Personalized plans that complement your training</p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
}
